import { useBadgingTranslation } from '../../../../ui/hooks';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
export function useAccountBadgeHistoryTableColumns() {
    const settings = useSelector(getSettings);
    const { t } = useBadgingTranslation();
    const columns = [
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.action'),
            cellFunction: (row) => t(`badges.badgeDetails.badgeHistoryTable.filters.actions.${row.columns.action}`),
            sortKey: 'action',
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.note'),
            cellFunction: (row) => { var _a; return (_a = row.columns.note) !== null && _a !== void 0 ? _a : '-'; },
            sortKey: 'note',
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.dateAndTime'),
            cellFunction: (row) => row.columns.createdAt && Number.isInteger(row.columns.createdAt) ? new Date(row.columns.createdAt).toLocaleString() : '',
            sortKey: 'createdAt',
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.updateBy'),
            cellFunction: (row) => row.columns.createdByEmail,
            sortKey: 'createdByEmail',
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.role'),
            cellFunction: (row) => settings.systemRoleMap[row.columns.createdByRole].label,
            sortKey: 'createdByRole',
        },
    ];
    return columns;
}
